document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document.querySelectorAll(".menu__item");
  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      item.classList.add("active");
      item.querySelector(".header__dropdown").classList.add("is-visible");
    });
    item.addEventListener("mouseleave", () => {
      item.classList.remove("active");
      item.querySelector(".header__dropdown").classList.remove("is-visible");
    });
  });

  const menuLinks = document.querySelectorAll(".link__item[data-target]");
  const menuProducts = document.querySelectorAll(".header__products-container");
  menuLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      menuLinks.forEach((link) => {
        link.classList.remove("active");
      });
      link.classList.add("active");
      const target = link.dataset.target;
      menuProducts.forEach((product) => {
        if (product.dataset.target === target) {
          product.classList.add("active");
        } else {
          product.classList.remove("active");
        }
      });
    });
  });

  const drawerItems  = document.querySelectorAll("[data-drawer-title]");
  drawerItems.forEach(item => { 
    item.addEventListener('click', () => { 
      if (item.classList.contains('active')) {
        item.classList.remove('active');
        item.nextElementSibling.classList.remove('active');
      }else{
        item.classList.add('active');
        item.nextElementSibling.classList.add('active');
      }
    })
  })
});
